import { Actions } from '@ngrx/effects';
import { AppState } from '@_store/index.reducers';
import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { CompanyCommunicationApiService } from '@_services/api/company-communication-api.service';
import { GeneratedCompanyCommunicationEffects } from './company-communication-generated.effects';

@Injectable()
export class CompanyCommunicationEffects extends GeneratedCompanyCommunicationEffects {
  constructor(
    actions$: Actions,
    companyCommunicationApiService: CompanyCommunicationApiService,
    store$: Store<AppState>
  ) {
    super(actions$, companyCommunicationApiService, store$);
  }
}
